import type { CalendarMoonPhaseId } from '@/api/schema/calendar'
import firstQuarter from '@/app/icons/moon/first-quarter.svg'
import fullMoon from '@/app/icons/moon/full-moon.svg'
import lastQuarter from '@/app/icons/moon/last-quarter.svg'
import newMoon from '@/app/icons/moon/new-moon.svg'
import waningCrescent from '@/app/icons/moon/waning-crescent-2.svg'
import waningGibbous from '@/app/icons/moon/waning-gibbous-2.svg'
import waxingCrescent from '@/app/icons/moon/waxing-crescent-2.svg'
import waxingGibbous from '@/app/icons/moon/waxing-gibbous-2.svg'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

const ICONS: Record<CalendarMoonPhaseId, string> = {
  new_moon: newMoon,
  waxing_crescent: waxingCrescent,
  first_quarter: firstQuarter,
  waxing_moon: waxingGibbous,
  full_moon: fullMoon,
  waning_moon: waningGibbous,
  last_quarter: lastQuarter,
  waning_crescent: waningCrescent,
}

export const MoonIcon: FunctionalComponent<{
  phase: CalendarMoonPhaseId
}> = props => {
  return (
    <img
      class={styles.root}
      src={ICONS[props.phase]}
      alt=''
    />
  )
}
